// modalController.ts
let alertModalImpl: (message: string, title?: string) => Promise<void> = () => {
  throw new Error("alertModal not initialized");
};

let confirmModalImpl: (message: string, title?: string) => Promise<boolean> = () => {
  throw new Error("confirmModal not initialized");
};

export function setModalHandlers({
  alertModal,
  confirmModal
}: {
  alertModal: (message: string, title?: string) => Promise<void>,
  confirmModal: (message: string, title?: string) => Promise<boolean>
}) {
  alertModalImpl = alertModal;
  confirmModalImpl = confirmModal;
}

export function alertModal(message: string, title?: string) {
  return alertModalImpl(message, title);
}

export function confirmModal(message: string, title?: string) {
  return confirmModalImpl(message, title);
}
